// extracted by mini-css-extract-plugin
module.exports = {"container":"newBusinessInsightsMenu_container__3wQZQ","insightsList":"newBusinessInsightsMenu_insightsList__q_z-s","active":"newBusinessInsightsMenu_active__y0UTW"};